export enum EVENT_FREQUENCY {
    HOUR = 'hour',
    DAY = 'day',
}

export interface ISettings {
    priceResponse: {
        cooldownHours: number;
        maxDispatchesPerDay: number;
    };
    cleanResponse: {
        eventPer: EVENT_FREQUENCY;
    };
}
